// extracted by mini-css-extract-plugin
export default {"verificationsuccesslogo":"Success_verificationsuccesslogo__S3Kmj","successtext":"Success_successtext__AszzN","completetext":"Success_completetext__ujeuo"};